import { render, staticRenderFns } from "./SingleClickAutocomplete.vue?vue&type=template&id=cd95d2d0"
import script from "./SingleClickAutocomplete.vue?vue&type=script&lang=js"
export * from "./SingleClickAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports